module.exports = __webpack_public_path__ + "img/entre-nous-juin-2021.6a92a726.jpg";